import { AscActivityType } from "../../components/AscCards/AscActivityTypeCard/AscActivityTypeCard.types";
import {
  AudioRecorderIcon,
  BranchingScenariosIcon,
  CrosswordIcon,
  DragAndDropIcon,
  DragTheWordIcon,
  EssayIcon,
  FindWordIcon,
  FlashcardIcon,
  ImageHotspotIcon,
  MarkTheWordIcon,
  QuizIcon,
  TimelineIcon,
  TrueFalseIcon,
  VoiceMessageIcon,
} from "../../components/AscIcons";

export const ACTIVITY_TYPES: Record<AscActivityType, {
    title: string;
    description: string;
    icon: JSX.Element;
}>
  = {
  dragDrop: {
    title: "Drag and Drop",
    description: "Categorize The Following",
    icon: <DragAndDropIcon data-testid="DragAndDropIcon" />,
  },
  crossword: {
    title: "Crossword",
    description: "Use the clues to find the right word",
    icon: <CrosswordIcon data-testid="CrosswordIcon" />,
  },
  findWord: {
    title: "Find the words",
    description: "The right answer is in the noise ",
    icon: <FindWordIcon data-testid="FindWordIcon" />,
  },
  trueFalse: {
    title: "True or False",
    description: "Boiled it down to 2 options",
    icon: <TrueFalseIcon data-testid="TrueFalseIcon" />,
  },
  markWord: {
    title: "Mark the word",
    description: "Identify the important words from the rest",
    icon: <MarkTheWordIcon data-testid="MarkTheWordIcon" />,
  },
  dragWord: {
    title: "Drag the word",
    description: "Match the options to the right question",
    icon: <DragTheWordIcon data-testid="DragTheWordIcon" />,
  },
  essay: {
    title: "Essay",
    description: "Tell us your thoughts",
    icon: <EssayIcon data-testid="EssayIcon" />,
  },

  branchingScenarios: {
    title: "Branching scenarios",
    description: "Activity type description text",
    icon: <BranchingScenariosIcon data-testid="BranchingScenariosIcon" />,
  },
  flashcards: {
    title: "Flashcards",
    description: "Use the image to find the answer",
    icon: <FlashcardIcon data-testid="FlashcardIcon" />,
  },
  imageHotspot: {
    title: "Image hotspot",
    description: "Activity type description text",
    icon: <ImageHotspotIcon data-testid="ImageHotspotIcon" />,
  },
  quiz: {
    title: "Quiz",
    description: "Find the best answer for this situation test",
    icon: <QuizIcon data-testid="QuizIcon" />,
  },
  assessment: {
    title: "Assessment",
    description: "Find the best answer for this situation test",
    icon: <QuizIcon data-testid="QuizIcon" />,
  },
  quizDragDrop: {
    title: "Quiz",
    description: "Choose the right image for each option",
    icon: <QuizIcon data-testid="QuizIcon" />,
  },
  timeline: {
    title: "Timeline",
    description: "Put actions in the right order",
    icon: <TimelineIcon data-testid="TimelineIcon" />,
  },
  voiceMessage: {
    title: "Voice Answer",
    description: "Activity type description text",
    icon: <VoiceMessageIcon data-testid="VoiceMessageIcon" />,
  },
  audioRecorder: {
    title: "Audio Recorder",
    description: "Activity type description text",
    icon: <AudioRecorderIcon data-testid="AudioRecorderIcon" />,
  },
};
